/**
 * Workflow 설정 전용 라우트 (/workflow-settings)
 * @description 기존 admin UI가 아닌 독립 화면, 왼쪽 메뉴 레이아웃
 */

import { createFileRoute } from '@tanstack/react-router';
import { WorkflowSettingsLayout } from '@/layouts/WorkflowSettingsLayout';
import { requireWorkflowSettingsAccess } from '@/utils/authGuard';

export const Route = createFileRoute('/workflow-settings')({
  beforeLoad: async ({ location }) => {
    await requireWorkflowSettingsAccess({ location });
  },
  component: WorkflowSettingsLayout,
});
